import { render, staticRenderFns } from "./ComboRecipe.vue?vue&type=template&id=ad88a28e&scoped=true"
import script from "./ComboRecipe.vue?vue&type=script&lang=js"
export * from "./ComboRecipe.vue?vue&type=script&lang=js"
import style0 from "./ComboRecipe.vue?vue&type=style&index=0&id=ad88a28e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad88a28e",
  null
  
)

export default component.exports